<template>
  <div class="TransactionList">
    <CRUDList
      ref="crudList"
      :canAdd="true"
      :canEdit="true"
      :canApply="false"
      :canSave="true"
      :canDelete="true"
      :headers="headers"
      :showSelect="false"
      :showDate="true"
      :showTotal="true"
      :baseCrudKey="baseCrudKey"
      :defaultSortBy="sortBy"
      :loadingData="gridLoading.flag"
      :loadingText="gridLoading.text"
      toolbarTitle="Exempt Mortgagees"
      @loadCRUDList="handleLoadCRUDList"
      @upsertItem="upsrtTransaction"
      @emitDeleteRowItem="deleteTransaction">
      <template v-slot:[`editedItem`]="{}">
        <div>
          <v-text-field
          label="Exempt Mortgagees"
          v-model="editedItem.exemptMortgagees" />
        </div>
      </template>
    </CRUDList>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions,
  mapMutations,
} from 'vuex';
import CRUDList from '../../common/base/crud/CRUDList.vue';
import {
  manageGridLoading,
  amountFormat,
  defaultGridLoading,
} from '../../../util/shared/vue-global';

const getHeaders = () => {
  const headers = [
    { text: 'Exempt Mortgagees', value: 'exemptMortgagees' },
  ];
  return headers;
};

export default {
  name: 'ExemptMortgageesList',
  data: () => ({
    baseCrudKey: 'exemptMortgageesForMtg',
    gridLoading: defaultGridLoading(),
    sortBy: [
      {
        column: 'exemptMortgagees',
        direction: 'asc',
      },
    ],
  }),
  created() {
    this.headers = getHeaders();
    this.initCriteria();
  },
  components: {
    CRUDList,
  },
  computed: {
    ...mapGetters('base/crud', [
      'item', 'criteria',
    ]),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    amountFormat,
    manageGridLoading,
    ...mapActions('mtg/mtgTransaction', [
      'exemptMortgageesForMtg',
      'upsertExemptMortgagees',
      'deleteExemptMortgagees',
    ]),
    ...mapMutations('base/crud', [
      'setItem',
    ]),
    initCriteria() {
      this.handleLoadCRUDList();
    },
    handleLoadCRUDList() {
      const criteria = this.criteria(this.baseCrudKey) || {};
      this.exemptMortgageesForMtg({
        baseCrudKey: this.baseCrudKey,
        criteria,
      }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    upsrtTransaction(item) {
      const updatedItem = { ...item };
      if (!updatedItem.exemptMortgagees) return;

      this.upsertExemptMortgagees({
        item: updatedItem,
        baseCrudKey: this.baseCrudKey,
      });
    },
    deleteTransaction(item) {
      if (!item._id) return;
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        this.deleteExemptMortgagees({ item, baseCrudKey });
      }
    },
  },
};
</script>
